<template>
    <div>
        <div class="user_right">
            <h1 class="urs_h1">订单</h1>
            <div class="od_stus" style="background-color:#f00180">
                <p class="od_tt">
                    <img src="https://s.cccgx.com/mobile/asset/css/u/u_ods3.png" class="od_img">
                    {{orderAr.status}}
                </p>
                <p class="od_sub">订单{{orderAr.status}}</p>
            </div>
            <div class="ysd_box">
                <div class="u_ifo">
                    <img src="https://s.cccgx.com//themes/v4/css/u/u_od_dz.png" class="u_if_img">
                    <p class="u_if_name">{{orderAr.mail_name}} {{orderAr.mail_tel}}</p>
                    <p class="u_ifdress">{{orderAr.mail_province}}{{orderAr.mail_city}}{{orderAr.mail_area}}{{orderAr.mail_town}}{{orderAr.mail_address}}</p>
                </div>
            </div>
            <!--one over-->
            <!--商品begin-->
            <div class="goods_bx">
                <!-- <div class="goods_pone goods_offs" v-for="(pro,index) in orderInf" :key="index"> -->
                <div class="goods_pone goods_offs">
                    <router-link :to="{path:'/detail', query:{id:orderInfo.pid}}" target="_blank" class="by_a">
                        <img :src="orderInfo.piclink" width="45" height="45" class="by_pic">
                        <p class="by_tt">{{orderInfo.title}}</p>
                        <p class="by_atr">{{orderInfo.sku_cn}}</p>
                        <em class="by_price">¥{{$fnc.toFixedZ(orderInfo.money)}}</em>
                        <em class="by_num">X{{orderInfo.number}}</em>
                    </router-link>
                </div>
                <div class="wai" id="amlit">
                    <p class="over">
                        <em class="left">商品总价</em>
                        <em class="right">¥{{$fnc.toFixedZ(orderInfo.money)}}</em>
                    </p>
                    <p class="over">
                        <em class="left">优惠折扣</em>
                        <em class="right">¥{{$fnc.toFixedZ(orderInfo.red_money)}}</em>
                    </p>
                    <p class="over">
                        <em class="left">运费</em><em class="right">免邮</em>
                    </p>
                    <p class="btf"></p>
                    <div class="over">
                        <span class="left">{{orderInfo.number}}件商品</span>
                        <p class="right">
                            总计<b class="red">¥</b>
                            <b class="red f16">{{$fnc.toFixedZ(orderInfo.money)}}</b>
                        </p>
                    </div>
                    <div class="over">
                        <a class="db_btn" href="javascript:;" @click="$router.push({path: '/detail', query:{id:orderInfo.cid}})" v-if="orderAr.status=='已完成'">再次购买</a>
                    </div>
                    <!--wai over-->
                </div>
            </div>
            <!--商品over-->
            <div class="order_msg">
                <h2 class="od_msgt">申请退款</h2>
                <div class="od_msg">
                    <div class="od_ob" style="margin-bottom:20px;" v-if="orderInfo.status==0">
                        <h3 style="font-size:14px;">退款原因：</h3>
                        <el-select v-model="radio" placeholder="请选择">
                            <el-option v-for="(item,index) in reason" :key="index" :label="item" :value="item">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="od_ob" style="margin-bottom:20px;">
                        <h3 style="font-size:14px;">退款金额：</h3>
                        <span style="font-size:16px;color:#f00180;font-weight:bold;">￥{{$fnc.toFixedZ(orderInfo.money)}}</span>
                    </div>
                    <div class="od_ob" style="margin-bottom:20px;" v-if="orderInfo.status!=0">
                        <h3 style="font-size:14px;">退款原因：</h3>
                        <span style="font-size:16px;color:#f00180;font-weight:bold;">{{orderInfo.return_reason}}</span>
                    </div>
                    <div class="od_ob" style="margin-bottom:20px;" v-if="orderInfo.status!=0">
                        <h3 style="font-size:14px;">退款说明：</h3>
                        <span style="font-size:16px;color:#f00180;font-weight:bold;">{{orderInfo.return_instructions}}</span>
                    </div>
                    <div class="od_ob" style="margin-bottom:20px;" v-if="orderInfo.status==0">
                        <h3 style="font-size:14px;">退款说明：</h3>
                        <textarea maxlength="800" name="" placeholder="选填" class="ap_t" id="c_des" v-model="return_instructions"></textarea>
                    </div>
                    <div class="od_ob" style="margin-bottom:20px;" v-if="orderInfo.status>1">
                        <h3 style="font-size:14px;">退货收件人姓名：</h3>
                        <span>{{orderInfo.return_name}}</span>
                    </div>
                    <div class="od_ob" style="margin-bottom:20px;" v-if="orderInfo.status>1">
                        <h3 style="font-size:14px;">退货收件人电话：</h3>
                        <span>{{orderInfo.return_name}}</span>
                    </div>
                    <div class="od_ob" style="margin-bottom:20px;" v-if="orderInfo.status>1">
                        <h3 style="font-size:14px;">退货收件人地址：</h3>
                        <span>{{orderInfo.return_name}}</span>
                    </div>
                    <div v-if="!$store.state.isSupplier">
                        <div v-if="orderInfo.status==2 || orderInfo.status==3">
                            <div class="od_ob" style="margin-bottom:20px;">
                                <h3 style="font-size:14px;">物流公司：</h3>
                                <input type="text" class="ap_t_e" id="c_des" :disabled="orderInfo.status!=2" v-model="orderInfo.return_mail" placeholder="请填写物流公司">
                            </div>
                            <div class="od_ob" style="margin-bottom:20px;">
                                <h3 style="font-size:14px;">物流单号：</h3>
                                <input type="text" class="ap_t_e" id="c_des" :disabled="orderInfo.status!=2" v-model="orderInfo.return_mail" placeholder="请填写物流单号">
                            </div>
                        </div>
                    </div>
                    <div class="od_ob">
                        <!-- <input type="submit"  @click="subRefund" class="b_sub" v-if="orderInfo.status==0">提交 -->
                        <el-button type="danger" @click="subRefund" class="b_sub" v-if="orderInfo.status==0">提交</el-button>
                        <el-button type="danger" size="large" disabled v-else-if="orderInfo.status==1">退货申请中</el-button>

                        <el-button type="danger" size="large" @click="setOrderMail" v-else-if="orderInfo.status==2">提交物流信息</el-button>

                        <el-button type="danger" size="large" disabled v-else-if="orderInfo.status==3">审核退款中</el-button>

                        <el-button type="danger" size="large" disabled v-else-if="orderInfo.status==4">退货完成</el-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return{
            return_instructions: '',
            radio: '请选择',
            message:"",
            pro_length:"",
            orderInfo: {
                return_mail: '',
                return_oid: '',
                
            },
            reason: [],
            pro_status: '',
            show: false,
            pic: [],
            orderAr:'',
        }
    },
    created(){
        // this.getOrderDetails();
        this.getApplication();
        this.subRefund();
    },
    methods:{
        subRefund () {
            if (this.radio == '请选择') {
                // this.$toast.fail("请选择退货理由");
                this.$alert('请选择退货理由', '提示', {
                    confirmButtonText: '确定',
                });
                return false;
            } else {
                var params = {};
                params.id = this.$route.query.id || '';
                params.uid = JSON.parse(window.localStorage.getItem("user")).id || '';
                params.return_reason = this.radio;
                params.return_instructions = this.return_instructions;
                params.pic = this.pic.join('@');
                this.$api.getOrder.setOrderRefund(params).then(res => {
                    if (res.code == 200) {
                        // this.$toast.success(res.result);
                        this.$alert(`${res.result}`, '提示', {
                            confirmButtonText: '确定',
                        });
                        setTimeout(() => {
                            this.getApplication();
                        }, 1500)
                    }
                })
            }
        },
        getApplication(){
            var params = {}
            params.id = this.$route.query.id || "";
            params.uid = JSON.parse(window.localStorage.getItem("user")).id || "";
            this.$api.getOrder.getApplication(params).then(res => {
                if(res.code == 200){
                    console.log(res)
                    this.orderInfo = res.result;
                    this.orderAr = res.result.order_ar;
                    if (this.$route.query.types == 9) {
                        this.reason = res.result.tour_reason || [];
                    } else {
                        this.reason = res.result.reason || [];
                    }
                    // this.radio=res.result.return_reason || '';
                    this.pic = [];
                    if (res.result.pic.length > 0 && res.result.status > 0) {
                        for (var i in res.result.pic)
                        this.pic.push(res.result.pic[i].piclink);
                    }
                }
            })
        },
        setOrderMail () {
            if (this.return_mail == '' || this.return_oid == '') {
                // this.$toast.fail("物流信息不能为空");
                this.$alert('物流信息不能为空', '提示', {
                    confirmButtonText: '确定',
                });
                return;
            } else {
                var params = {};
                params.id = this.$route.query.id || '';
                params.uid = JSON.parse(window.localStorage.getItem("user")).id || '';
                params.return_mail = this.orderInfo.return_mail;
                params.return_oid = this.orderInfo.return_oid;
                this.$api.getOrder.setOrderMail(params).then(res => {
                    if (res.code == 200) {
                        this.$toast.success(res.result);
                        setTimeout(() => {
                            this.getApplication();
                        }, 1500)
                    }
                })
            }
        },
        sub_btn(){}
    }
}
</script>

<style scoped>
@import url('../../assets/css/user.css');
.ap_t{
    border: 1px solid #efefef;
    padding: 10px;
    border-radius: 8px;
    margin-bottom: 10px;
    /* line-height: 2rem; */
    background-color: #fff;
    width: 100%;
    height: 100px;
}
.ap_t_e{
    border: 1px solid #efefef;
    padding: 10px;
    border-radius: 8px;
    margin-bottom: 10px;
    /* line-height: 2rem; */
    background-color: #fff;
    width: 100%;
    /* height: 100px; */
}
</style>


// WEBPACK FOOTER //
// src/components/orderrefund/index.vue